class cAdminSeries {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;

        var elBtnAdd = $('#addseries');
        var elSeriesTable = $('#series-table');
        var elAddSeriesSubmitBtn = $('#add-series-submit-btn');
        var elEditSeriesSubmitBtn = $('#edit-series-submit-btn');
        this.elSeriesAddForm = $('#series-add-form');
        this.elSeriesEditForm = $('#series-edit-form');


        //elBtnAdd.click( function(){self.onAddSeriesClick(btn, e);} );
        elSeriesTable.click(function (e) { self.seriesTableClickHandler(e); });
        elAddSeriesSubmitBtn.click(function (e) { self.submitAddSeries(this, e); });
        elEditSeriesSubmitBtn.click(function (e) { self.submitEditSeries(this, e); });

        $(elSeriesTable).dataTable({
            'paging': true,
            'pageLength': 100,
            'info': true,
            'order': [[1, 'asc']],
            'columnDefs': [
                { "orderable": false, "targets": [0, 4] }
            ],
            //Text translation options
            //Note the required keywords between underscores (e.g _MENU_)
            oLanguage: {
                sSearch: 'Search all columns:',
                sLengthMenu: '_MENU_ Series per page',
                info: 'Showing page _PAGE_ of _PAGES_',
                zeroRecords: 'Nothing found - sorry',
                infoEmpty: 'No records available',
                infoFiltered: '(filtered from _MAX_ total records)'
            }
        });

    }
    submitAddSeries(btn, e) {
        if (!$(this.elSeriesAddForm).find('*[name="name"]').val()) {
            return notify.error("Please specify a name for the series");
        } else if (!$(this.elSeriesAddForm).find('*[name="description"]').val()) {
            return notify.error("Please specify a description for the series");
        }

        $(btn).button('loading');

        $(this.elSeriesAddForm).ajaxSubmit({
            url: URL_ADMIN + '/series/addseries/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                } else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return;
    }
    submitEditSeries(btn, e) {
        if (!$(this.elSeriesEditForm).find('*[name="name"]').val()) {
            return notify.error("Please specify a name for the series");
        } else if (!$(this.elSeriesEditForm).find('*[name="description"]').val()) {
            return notify.error("Please specify a description for the series");
        }

        $(btn).button('loading');

        $(this.elSeriesEditForm).ajaxSubmit({
            url: URL_ADMIN + '/series/updateseries',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                } else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }
    seriesTableClickHandler(e) {
        var target = e.target;
        var row = $(target).closest('tr').get(0);

        if ($(target).hasClass('edit')) {
            this.onSeriesEditClick(row);
        } else if ($(target).hasClass('del')) {
            this.onSeriesDelClick(row);
        }
    }
    onSeriesEditClick(row) {
        $('#edit-series-modal').find('#edit-id').val($(row).data('id'));
        $('#edit-series-modal').find('#edit-name').val($(row).data('name'));
        $('#edit-series-modal').find('#edit-description').val($(row).data('description'));
        $('#edit-series-modal').find('#edit-parent-id').val($(row).data('parentId'));
        if ($(row).data('isCollection') === 1) {
            $('#edit-series-modal').find('#is-collection-yes').val(1);
            $('#edit-series-modal').find('#is-collection-yes').prop('checked', true);
        } else {
            $('#edit-series-modal').find('#is-collection-no').val(0);
            $('#edit-series-modal').find('#is-collection-no').prop('checked', true);
        }
        $('#edit-series-modal').modal('show');
    }
    getSeriesById(seriesId) {
        for (var i in g_books_series) {
            if (g_books_series[i].id == seriesId) {
                return g_books_series[i];
            }
        }
        return null;
    }
    onSeriesDelClick(row) {
        var seriesId = row.getAttribute('rel');
        if (confirm('Are you sure you want to delete this series?')) {
            this.deleteSeries(seriesId);
        }
    }
    deleteSeries(series_id) {
        var form = $('<form action="#" method="post"><input type="hidden" name="id" value="' + series_id + '"/></form>');
        $('body').append(form);

        $(form).ajaxSubmit({
            url: URL_ADMIN + '/series/deleteseries/',
            type: 'post',
            dataType: 'json',
            data: {
                series_id: series_id
            },
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                } else {
                    notify.error(response.errors[0]);
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return;
    }
}










